import { toast } from 'react-toastify'

export const isToastActive = (toastId: string) => toast.isActive(toastId)
